/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} DetailsInputs */

const en_details = /** @type {(inputs: DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details`)
};

const es_details = /** @type {(inputs: DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalles`)
};

const fr_details = /** @type {(inputs: DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détails`)
};

const de_details = /** @type {(inputs: DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details`)
};

const id_details = /** @type {(inputs: DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detail`)
};

/** @type {(inputs: DetailsInputs) => LocalizedString} */
const ja_details = en_details;

/** @type {(inputs: DetailsInputs) => LocalizedString} */
const zh_details = en_details;

/** @type {(inputs: DetailsInputs) => LocalizedString} */
const ar_details = en_details;

/** @type {(inputs: DetailsInputs) => LocalizedString} */
const it_details = en_details;

/** @type {(inputs: DetailsInputs) => LocalizedString} */
const ru_details = en_details;

/** @type {(inputs: DetailsInputs) => LocalizedString} */
const pt_details = en_details;

/** @type {(inputs: DetailsInputs) => LocalizedString} */
const ko_details = en_details;

/**
* | output |
* | --- |
* | "Details" |
*
* @param {DetailsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const details = /** @type {((inputs?: DetailsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<DetailsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_details(inputs)
	if (locale === "es") return es_details(inputs)
	if (locale === "fr") return fr_details(inputs)
	if (locale === "de") return de_details(inputs)
	if (locale === "ja") return ja_details(inputs)
	if (locale === "zh") return zh_details(inputs)
	if (locale === "ar") return ar_details(inputs)
	if (locale === "id") return id_details(inputs)
	if (locale === "it") return it_details(inputs)
	if (locale === "ru") return ru_details(inputs)
	if (locale === "pt") return pt_details(inputs)
	return ko_details(inputs)
});